import { Dialog, DialogProps, useGraphqlDelete, useListGraphqlQuery, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component"
import { TUserStudentScholarity } from "@bsm/graphql";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SCHOLARITY_LIST_ID } from "../container/ScholarityListContainer";

export const DeleteScholarityDialog = (props: TProps) => {

    const [
        OK,
        CANCEL,
    ] = useTranslations(i18n);

    const deleteMutation = useGraphqlDelete('scholarity')
    const navigate = useNavigate();
    const tr = useTranslationRoute()
    const urlParams = useUrlParamsValueToString()
    const { invalidateQuery } = useListGraphqlQuery(SCHOLARITY_LIST_ID);

    useEffect(() => {
        if (deleteMutation.isSuccess) {
            invalidateQuery()
            navigate(tr(`admin/students/viewer/scholarity?${urlParams}`))
        }
    }, [deleteMutation])

    return (
        <Dialog
            title={"Delete scholarity"}
            open={props.open}
            confirmation
            onClose={props.onClose}
            onCancel={props.onClose}
            onConfirm={() => deleteMutation.mutate({ ids: [props?.id] })}
            btnOk={{ label: OK, isSubmit: deleteMutation.isLoading }}
            btnCancel={{ label: CANCEL }}
        >
            Are you sure you want to delete this scholarity ?
        </Dialog>
    )
}

const i18n = [
    "std_confirm",
    "std_cancel",
]

type TProps = Partial<TUserStudentScholarity> & Partial<DialogProps> 